import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowPointer,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowUp,
  faArrowDown,
  faBars,
  faCalendarAlt,
  faCamera,
  faCaretDown,
  faCheck,
  faCircle,
  faCircleArrowRight,
  faCircleQuestion,
  faClone,
  faCogs,
  faComment,
  faCommentDots,
  faCompress,
  faCopy,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faExpand,
  faExpandAlt,
  faExpandArrowsAlt,
  faEye,
  faEyeSlash,
  faFastBackward,
  faFastForward,
  faFileImport,
  faFolder,
  faFont,
  faGear,
  faGift,
  faGrip,
  faHandPointer,
  faHeart,
  faICursor,
  faImage,
  faImages,
  faInfoCircle,
  faMagnifyingGlass,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faPalette,
  faPause,
  faPauseCircle,
  faPhotoVideo,
  faPlay,
  faPlayCircle,
  faPlus,
  faQrcode,
  faRocket,
  faRotateLeft,
  faRotateRight,
  faRotate,
  faSearch,
  faSquareCheck,
  faSquareMinus,
  faTimes,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faTrophy,
  faVideo,
  faWandMagicSparkles,
  faWheelchair,
  faWindowMaximize,
  faXmark,
  faChevronLeft,
  faChevronRight,
  faBook,
  faArrowRotateLeft,
  faCalendar,
  faCalendarDay,
  faChevronDown,
  faChevronUp,
  faFilm,
  faArrowLeft,
  faUniversalAccess,
  faTv,
  faLightbulb,
  faSignOut,
  faLink,
  faBullhorn,
  faPen,
  faUserPlus,
  faUserPen,
} from "@fortawesome/free-solid-svg-icons";

import {
  faXTwitter,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons"; // Added faTwitterSquare from addIcons.js

const icons = [
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowPointer,
  faArrowRight,
  faArrowRightFromBracket,
  faBars,
  faCalendarAlt,
  faCamera,
  faCaretDown,
  faCheck,
  faCircle,
  faCircleArrowRight,
  faCircleQuestion,
  faClone,
  faCogs,
  faComment,
  faCommentDots,
  faCompress,
  faCopy,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faExpand,
  faExpandAlt,
  faExpandArrowsAlt,
  faEye,
  faEyeSlash,
  faFastBackward,
  faFastForward,
  faFileImport,
  faFolder,
  faFont,
  faGear,
  faGift,
  faGrip,
  faHandPointer,
  faHeart,
  faICursor,
  faImage,
  faImages,
  faInfoCircle,
  faMagnifyingGlass,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faPalette,
  faPause,
  faPauseCircle,
  faPhotoVideo,
  faPlay,
  faPlayCircle,
  faPlus,
  faQrcode,
  faRocket,
  faRotateLeft,
  faRotateRight,
  faSearch,
  faSquareCheck,
  faSquareMinus,
  faTimes,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faTrophy,
  faVideo,
  faWandMagicSparkles,
  faWheelchair,
  faWindowMaximize,
  faXmark,
  faChevronLeft,
  faChevronRight,
  faBook,
  faArrowRotateLeft,
  faCalendar,
  faCalendarDay,
  faChevronDown,
  faChevronUp,
  faFilm,
  faArrowLeft,
  faUniversalAccess,
  faArrowUp,
  faArrowDown,
  faTv,
  faLightbulb,
  faSignOut,
  faLink,
  faBullhorn,
  faRotate,
  faPen,
  faUserPlus,
  faUserPen,
];

library.add([...icons, faXTwitter, faTwitterSquare]); // Added faTwitterSquare from addIcons.js

export default icons;
